<template>
  <div @click="goBack()" class="car-btn-back" v-if="prevRoutes.length > 1">
    <div class="car-icon"></div>
    <span class="car-text">{{ $t('backBtn') }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BackBtn',
  data() {
    return {
      prevRoute: null
    }
  },
  methods: {
    goBack() {
      if (this.$route.name === 'conversation' || !this.prevRoutes.length) {
        return this.$router.go(-1);
      }
      return this.$router.push({ name: this.prevRoutes[this.prevRoutes.length - 2] })
    }
  },
  computed: {
    ...mapGetters('wizardData', ['prevRoutes'])
  }
}
</script>
